import {  faChevronDown, faCircleStop, faMagnifyingGlass, faPenToSquare, faPlay, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Tooltip } from 'react-tooltip';
import { getLanguage } from '../../RTK/Slice/UserSlice';
import { useDebounce } from 'use-debounce';
import { useTranslation } from 'react-i18next';
import GroupPhotoPic from "./../../Images/groupfacebookicon.png" ; 
import { Backdrop, Fade, Modal } from '@mui/material';
import { getActiveToken, getToken } from '../../RTK/Slice/Auth/AuthSlice';
import { getAllGroupsAPI, getAllGroupsInfo, getAllGroupsNextAPI, getHasNextGroup, postOnGroupAPI, stopNext } from '../../RTK/Slice/Groups/GroupSlice';
import { STATUS } from '../../Constants';
import LoaddingCommentComponent from '../Utils/LoaddingCommentComponent';
import photoPic from "./../../Images/photos.png" ; 
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';


const AllGroups = () => {

    // For Control Reply Modal
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    // For Set status of next group
    const [statusNext , setStatusNext] = useState('') ; // stop  || con

    // For Access Photo Input
    const [photoMessage , setPhotoMessage] = useState(null);

    // For store data request
    const formData = new FormData();
    
    const handleImageChange = (e) => {
        const file = e.target.files[0]; // Get the first selected file
        if (file) {
            setPhotoMessage(file); // Store the image file in state
      };
    
    }


    // For Control Show Dropdown menu OS
    const [menuPrivacy , setMenuPrivacy] = useState(false) ; 

    // For Set Os Filter
    const [privacy , setPrivacy] = useState('all')

    // For  Post Field
    const [post , writePost] = useState('') ; 

    // For Control Show Time Mneu 
    const [showTime , setShowTime] = useState(false) ; 

    // For Store Choose Time
    const [timer , setTime] = useState("") ; 

    // For Time Next
    const [timerNext , setTimeNext] = useState(0) ; 

    // For Make Translation
    const {t} = useTranslation() ;

    // For Get Token
    const token = useSelector(getToken) ; 

    // For Get User Token
    const userToken = useSelector(getActiveToken) ; 

    

    // For Dispatch Action
    const dispatch = useDispatch() ; 

    // For Get Has next
    const hasNext = useSelector(getHasNextGroup) ; 

    // For Get All Group 
    const getAllGroupsHandler = ()=>{
        dispatch(getAllGroupsAPI({token : token ?token :"" , userToken }))
    }

    useEffect(()=>{
        if(token)
        getAllGroupsHandler() ;
    } , []) ;

    // For Get All Groups
    const {status , allGroups} = useSelector(getAllGroupsInfo)



    // For Modal Style
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        p: 4,
        };

    // For Get Random Number Between 1min and 2 min
    function getRandomBetween1And2Minutes(args) {
        // Convert minutes to milliseconds
        const min = args.t1 * 1000; // 1 minute in milliseconds
        const max = args.t2  * 1000; // 2 minutes in milliseconds
        
        // Generate random number between min and max
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }




    // For Reply Comment Handler
    const writePostHandler = ()=>{
        if(selected.length > 0 ){
            if(userToken){
                if(post  && timer){
                    let time = 0;
                    for(let i = 0 ; i < selected.length ;i++) {
                        setTimeout(()=>{
                            formData.append("source" , photoMessage) ; 
                            formData.append("groupId" , selected[i]) ;
                            formData.append("caption" , post ) ; 
                            formData.append("published" , false ) ; 
                            formData.append("scheduled_publish_time" , 1486755500 ) ; 
                            formData.append("is_reusable" , true ) ; 
                            dispatch(postOnGroupAPI({token , userToken , data: formData , groupId :i})) ; 
                            formData.delete("source")
                            formData.delete("groupId")
                            formData.delete("caption")
                            formData.delete("scheduled_publish_time")
                            formData.delete("is_reusable")
                            formData.delete("published")
        
                        } , time)
                        time += getRandomBetween1And2Minutes(timer) ; 
                    }
    
                    const id = toast.loading("Wait until posting to selected groups...")
                    setTimeout(()=>{
                        toast.update(id, {
                            render: "Operation successful!",
                            type: "success",
                            isLoading: false, // Stop the loading spinner
                        autoClose: 3000, // Automatically close after 3 seconds
                      });
                } , time)
                    handleClose()
                    writePost("")
                }else{
                    toast.info("Please Write Post")
                }
            }else{
                toast.warn("Please Choose Token")
            }
        }else{
            toast.info("Please Chooose Groups")
        }
        
    }

    // For Render Post Modal
    const renderPostModal = ()=>{
        return (
            <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={handleClose}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
              backdrop: {
                timeout: 300,
              },
            }}
          >
            <Fade in={open}>
                <div className='k-modal my-font' style={style}>

                    <div className='head'>
                        <div className='left'>
                            <h3>Write Post</h3>
                            <p>Can write post to all group your are related</p>
                        </div>
                        <div className='right' onClick={handleClose}><FontAwesomeIcon  icon={faXmark} /></div>
                    </div>
                    <div className='body'>
                        <div className='write-message-con'>
                            <label className='' htmlFor='message-input'>Content </label>
                            <textarea value={post} onChange={(e)=>writePost(e.target.value)}  autoFocus placeholder={"Write Post"} className='message-field' id='message-input'></textarea>
                        </div>
                        {
                            <div className='choose-image' style={{height : "80px"}}>
                                <input accept="image/*" onChange={handleImageChange} type="file" />
                                <div className='center'>
                                    <img src={photoPic} alt='phots' />
                                    <p className='title'>Add Photos/Videos</p>
                                    <p className='des'> {photoMessage === null ? `or drag and drop` : photoMessage.name} </p>
                                </div>
                            </div>
                            
                        }

                        <div className='choose-time' onClick={()=>setShowTime(!showTime)}>
                            <p>{timer ? `Between ${timer.t1} sec and ${timer.t2} sec`: t("Time Between Send")}</p>
                            <FontAwesomeIcon icon={faChevronDown} />
                            
                             <ul className={`list-items ${showTime ? "list-items-show": "" }`}>
                                <li onClick={()=>setTime({t1 : 1 , t2 : 2})} >Between 1 sec and 2 sec</li>
                                <li onClick={()=>setTime({t1 : 3 , t2 : 5})} >Between 3 sec and 5 sec</li>
                                <li onClick={()=>setTime({t1 : 4 , t2 : 6})} >Between 4 sec and 6 sec</li>
                                <li onClick={()=>setTime({t1 : 7 , t2 : 8})} >Between 7 sec and 8 sec</li>
                                <li onClick={()=>setTime({t1 : 9 , t2 : 10})} >Between 9 sec and 10 sec</li>
                                <li onClick={()=>setTime({t1 : 10 , t2 : 15})} >Between 10 sec and 15 sec</li>
                                <li onClick={()=>setTime({t1 : 18 , t2 : 48})} >Between 15 sec and 20 sec</li>
                                <li onClick={()=>setTime({t1 : 30 , t2 : 60})} >Between 30 sec and 60 sec</li>
                                <li onClick={()=>setTime({t1 : 60 , t2 : 120})} >Between 1 min and 2 min</li>
                                <li onClick={()=>setTime({t1 : 180 , t2 : 240})} >Between 3 min and 4 min</li>
                                <li onClick={()=>setTime({t1 : 300 , t2 : 360})} >Between 5 min and 6 min</li>
                                <li onClick={()=>setTime({t1 : 420 , t2 : 480})} >Between 7 min and 8 min</li>
                                <li onClick={()=>setTime({t1 : 540 , t2 : 600})} >Between 9 min and 10 min </li>
                                <li onClick={()=>setTime({t1 : 600 , t2 : 900})} >Between 10 min and 15 min </li>
                            </ul>
                            
                            
                        </div>

                    </div>

                    <div className='btn'>
                        <button onClick={writePostHandler} >Post</button>
                    </div>

                </div>
                
            </Fade>
        </Modal>
        )
    }


    // For Store Search Input
    const [search , setSearch] = useState("") ; 
    const [value] = useDebounce(search , 300)

    // For Save Copy
    const [copyText , setCopyText] = useState("");

    // For Copy Text Handler
    const copyTextHandler = (text)=>{
        setCopyText(text) ; 
    }

    // For Store Selected Item
    const [selected , setSelected] = useState([]) ; 

    // For Detect Language
    const language = useSelector(getLanguage) ; 

    const [activeLang ] = useState(language ? language : 'ar') ;


    // For CheckBox Choose 
    const checkBoxHandler = (e)=>{

        let isSelectd = e.target.checked ;
        let value = e.target.value ; 
        if (isSelectd){
            setSelected([...selected , value])
        }else{
            setSelected((prevDate)=>{
                return prevDate.filter((id)=>{
                    return id !== value
                })
            })
        }
    }

    // For Select All Data 
    const selectAllHandler = (e)=>{
        let selectAll = e.target.checked ;
        if(selectAll){
        setSelected(allGroups
        .filter((item)=>value === ''  ? item : item?.name?.toLowerCase().includes(value))
        .filter((item)=>privacy === 'all' ? item : item.privacy.includes(privacy))
        .map((item)=>item.id))
        }else{
            setSelected([])
        }

    }

    // For Get The Next Group handler
    const getNextGroupHandler = ()=>{
        if(hasNext){
            dispatch(getAllGroupsNextAPI({userToken , hasNextGroup :hasNext , token}))
        }
    }


    // For Stop Get Next
    const stopNextHandler = ()=>{
        // dispatch(stopNext()) ;
        if(statusNext === "stop"){
            setStatusNext('con') ;
            
            console.log("You Should stoped")
        }else{
            setStatusNext('stop')
            dispatch(stopNext()) ; 
        }

    }


    // For Get The Next Default
    useEffect(()=>{
        if(hasNext && statusNext !== 'stop'){
            setTimeout(()=>{
                setTimeNext(  getRandomBetween1And2Minutes({t1 : 5, t2 : 10}));
                dispatch(getAllGroupsNextAPI({userToken , hasNextGroup :hasNext , token})) ;
            } , timerNext)
            // setTimeNext(prev => prev + getRandomBetween1And2Minutes({t1 : 2, t2 : 5}))
       } 
        
    } , [hasNext , statusNext ])



return (
    <div className='all-comment-page' style={{width : "860px" , overflowY : "hidden" ,maxWidth : "100%"}}>

        {renderPostModal()}

        <div className='tools-filter'>
            <div style={{display: "flex" , alignItems : "center" , flexWrap : "wrap"}}>
            
                <div className='search-bar'>
                    <FontAwesomeIcon icon={faMagnifyingGlass} />
                    <input value={search} onChange={(e)=>{ setSearch(e.target.value)}} placeholder={`Search`} />
                </div>
                <div className='os-drop-menu' onClick={()=>{setMenuPrivacy(!menuPrivacy)}}>
                    <p > {privacy ==='all'? 'All' : privacy ==='OPEN' ? 'OPEN' : privacy ==='CLOSED' ? 'CLOSED' : privacy === 'SECRET'?'SECRET' :"" }  <FontAwesomeIcon icon={faChevronDown} /></p>
                    <ul className={`type-os-dropdown ${menuPrivacy  ? 'type-os-dropdown-active' : 'type-os-dropdown-inactive'} ${activeLang === 'en' ? 'en' :'ar' } `}>
                        <li onClick={()=>{setPrivacy('all');setMenuPrivacy(false)}}>All </li>
                        <li onClick={()=>{setPrivacy('OPEN');setMenuPrivacy(false)}}>OPEN </li>
                        <li onClick={()=>{setPrivacy('CLOSED');setMenuPrivacy(false)}} >CLOSED </li>
                        <li onClick={()=>{setPrivacy('SECRET');setMenuPrivacy(false)}}>SECRET </li>
                    </ul>
                </div>
                <button className='stop-btn' onClick={stopNextHandler}>{statusNext === 'stop' ? <FontAwesomeIcon icon={faPlay} /> : <FontAwesomeIcon icon={faCircleStop} />} {statusNext === 'stop' ? "Continue" : "Stop"} </button>
            </div>
            <div className='btn-group'>
                <button className='btn-message' onClick={handleOpen}>Post <FontAwesomeIcon icon={faPenToSquare} /> </button>
            </div>
        </div>
        
        <div className='all-co' style={{height : "100%" , overflowY : "scroll" , paddingBottom : "86px"}}>
            <h2>The Number Of Selected {selected.length}</h2>
            <div className='comment-item-head'>
                <div className='item-check'><input style={{cursor : "pointer"}} onChange={selectAllHandler} type="checkbox" /> </div>
                <div className='item-comment_id'  >Group Photo</div>
                <div className='item-comment_user'> ID</div>
                <div className='item-content'>Group Name</div>
                <div className='item-os'>Group Privacy</div>
            </div>
            {
                status === STATUS.LOADDING ? (
                    <Fragment>
                        <LoaddingCommentComponent />
                        <LoaddingCommentComponent />
                        <LoaddingCommentComponent />
                    </Fragment>
                ) : ""
            }

            {
                
                allGroups.length === 0 ? <h2 style={{textAlign : "center" , marginTop : "20px"}}>There is no Comment</h2>: allGroups.filter((item)=> value === '' && privacy ==='all' ? item : item?.name?.toLowerCase().includes(value))
                .filter((item)=>privacy === 'all' ? item : item.privacy.includes(privacy))
                .map((item)=>{
                    return (
                        <div key={item.id} className='comment-item-body'>
                            <div className='item-check nor'><input style={{cursor :"pointer"}} value={item.id} checked={selected.includes(item.id)} onChange={checkBoxHandler} type="checkbox"  /></div>
                            <div className='item-comment_id nor'   > <Link to={item.id} style={{display : "block" ,textDecoration : "none"}} > <img loading="lazy" style={{width : "40px" , height : "40px" , borderRadius : "50%"}} src={item.cover?item.cover.source : GroupPhotoPic } alt='groupPhoto' /> </Link>  </div>
                            <div className='item-comment_user nor' data-tooltip-id="my-tooltip" data-tooltip-delay-show={800}  data-tooltip-content={item.id} onClick={()=>copyTextHandler(item.id)} >{item.id}</div>
                            <div className='item-content nor' data-tooltip-id="my-tooltip" data-tooltip-delay-show={800}  data-tooltip-content={item.name} onClick={()=>copyTextHandler(item.name)}>{item.name ?item.name.length > 20 ?`${item.name.slice(0 ,20)}...` :item.name : ""}</div>
                            <div className='item-os nor' onClick={()=>copyTextHandler(item.privacy)}>{item.privacy ?item.privacy  :""}</div>
                        </div>
                    )
                }) 
                
            }

            

            {/* For Pagination Next and Before */}
            
            {/*<div className="main-pagination">
                <div className="pagination-btn">
                </div>
                <div className="pagination-btn">
                    {hasNext ? (<button className="btn-pag" onClick={getNextGroupHandler} >Next</button>) : ""}
                    
                </div>
            </div>*/}

            {/* For Loadding */}
            {/* <Skeleton count={6} style={{width : "1020px", marginBottom : "4px" , height : "45px" , maxWidth : "100%" , borderRadius : "7px"}} />*/ }

            
            <Tooltip id="my-tooltip" />
        </div>
    </div>
)
}

export default AllGroups
